import { atom } from "jotai";

interface ChatModalAtomOptions {
    isOpen: boolean;
    startingPrompt?: string;
}

const ChatModalAtom = atom<ChatModalAtomOptions>({
    isOpen: false,
    startingPrompt: undefined,
});

export default ChatModalAtom;
